"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var _button = _interopRequireDefault(require("@paprika/button"));

var types = _interopRequireWildcard(require("../../types"));

var ButtonComponentMap = {
  icon: _button["default"].Icon,
  raw: _rawButton["default"],
  simple: _button["default"]
};

function Trigger(props) {
  var children = props.children,
      isOpen = props.isOpen,
      _onClick = props.onClick,
      onOpenMenu = props.onOpenMenu,
      menuRefId = props.menuRefId,
      triggerRef = props.triggerRef,
      buttonType = props.buttonType,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["children", "isOpen", "onClick", "onOpenMenu", "menuRefId", "triggerRef", "buttonType"]);
  var TriggerComponent = ButtonComponentMap[buttonType];
  return /*#__PURE__*/_react["default"].createElement(TriggerComponent, (0, _extends2["default"])({
    ref: triggerRef,
    "aria-controls": menuRefId,
    "aria-expanded": isOpen,
    "aria-haspopup": true,
    onClick: function onClick(e) {
      onOpenMenu();

      _onClick(e);
    },
    isSemantic: false
  }, otherProps), children);
}

Trigger.types = {
  button: types.buttonTypes
};
var propTypes = {
  children: _propTypes["default"].node,

  /** Determine the styling of the button */
  buttonType: _propTypes["default"].oneOf([Trigger.types.button.ICON, Trigger.types.button.RAW, Trigger.types.button.SIMPLE]),
  isOpen: _propTypes["default"].bool,
  menuRefId: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onOpenMenu: _propTypes["default"].func,
  triggerRef: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Object)
  }) || null
};
var defaultProps = {
  buttonType: Trigger.types.button.SIMPLE,
  children: null,
  menuRefId: "",
  triggerRef: null,
  isOpen: false,
  onClick: function onClick() {},
  onOpenMenu: function onOpenMenu() {}
};
Trigger.displayName = "OverflowMenu.Trigger";
Trigger.defaultProps = defaultProps;
Trigger.propTypes = propTypes;
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map